import React from "react";
import _Creatable, { Props as CreatableProps } from "react-select/creatable";
import _AsyncCreatable from "react-select/async-creatable";
import { AsyncProps } from "react-select/async";

export function Creatable<T>(props: CreatableProps<T>) {
  return (
    <_Creatable
      classNamePrefix="vseth-react-select"
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
        },
      })}
      {...props}
    />
  );
}

export function AsyncCreatable<T>(props: CreatableProps<T> & AsyncProps<T>) {
  return (
    <_AsyncCreatable
      classNamePrefix="vseth-react-select"
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
        },
      })}
      {...props}
    />
  );
}
